import { createSelector } from 'reselect';
import CarrierM39ComplianceDetailsColumns from '../../containers/CarrierM39ComplianceDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.isLoading;

export const getData =
  ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, CarrierM39ComplianceDetailsColumns);
